import { createZodDto } from './zod';

import { z } from 'zod';

export const CreateTransferSchema = z.object({
  toUserId: z.number(),
  toFolderId: z.number().nullable().optional(),
  equipmentIds: z.array(z.number()),
  senderComment: z.string().nullable().optional(),
  requiresAcknowledgment: z.boolean().optional().default(false),
  fileId: z.number().optional(),
});

export class CreateTransferDto extends createZodDto(CreateTransferSchema) {}

export const ValidateTokenSchema = z.object({
  token: z
    .string()
    .min(10)
    .max(100)
    .regex(/^[a-zA-Z0-9\-_]+$/),
});

export class ValidateTokenDto extends createZodDto(ValidateTokenSchema) {}

export const CheckTransferSchema = z.object({
  externalId: z
    .string()
    .min(10)
    .max(40)
    .regex(/^[a-z][a-z0-9]*$/),
});

export class CheckTransferDto extends createZodDto(CheckTransferSchema) {}

export const RespondToTransferSchema = z.object({
  token: z
    .string()
    .min(10)
    .max(100)
    .regex(/^[a-zA-Z0-9\-_]+$/),
  action: z.enum(['ACCEPT', 'DECLINE']),
  receiverComment: z.string().nullable().optional(),
  missingEquipmentIds: z.array(z.number()).optional(),
  equipmentUpdates: z
    .array(
      z.object({
        equipmentId: z.number(),
        serialNumber: z.string().nullable(),
        manufactureDate: z.coerce.date().nullable(),
      }),
    )
    .optional(),
});

export class RespondToTransferDto extends createZodDto(
  RespondToTransferSchema,
) {}
